import { render, staticRenderFns } from "./PriceSlider.vue?vue&type=template&id=d36b70dc"
import script from "./PriceSlider.vue?vue&type=script&lang=js"
export * from "./PriceSlider.vue?vue&type=script&lang=js"
import style0 from "./PriceSlider.vue?vue&type=style&index=0&id=d36b70dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports